import { createRouteFor } from "@components-common/routes";
import { dataSection, dataSectionBase } from "../routes.section";
const basePath = dataSectionBase;
const routesForLayerFunction = createRouteFor<typeof dataSection,"structural_layer_functions">(dataSection,"structural_layer_functions");

export const layerFunctionsRoutes = {
  index: routesForLayerFunction("index",{basePath})
}

export type StructuralLayerFunctionsRoutesIds = typeof layerFunctionsRoutes[keyof typeof layerFunctionsRoutes]["id"];
